"use client";
import * as u from "react";
import { u as g } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as F } from "./CompositeListContext-DMgUtso4.mjs";
let I = /* @__PURE__ */ function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
}({});
function N(t = {}) {
  const {
    label: i,
    metadata: a,
    textRef: s,
    indexGuessBehavior: L
  } = t, {
    register: m,
    unregister: d,
    subscribeMapChange: p,
    elementsRef: x,
    labelsRef: f,
    nextIndexRef: C
  } = F(), l = u.useRef(-1), [n, R] = u.useState(L === I.GuessFromOrder ? () => {
    if (l.current === -1) {
      const e = C.current;
      C.current += 1, l.current = e;
    }
    return l.current;
  } : -1), o = u.useRef(null), b = u.useCallback((e) => {
    var r;
    if (o.current = e, n !== -1 && e !== null && (x.current[n] = e, f)) {
      const c = i !== void 0;
      f.current[n] = c ? i : ((r = s == null ? void 0 : s.current) == null ? void 0 : r.textContent) ?? e.textContent;
    }
  }, [n, x, f, i, s]);
  return g(() => {
    const e = o.current;
    if (e)
      return m(e, a), () => {
        d(e);
      };
  }, [m, d, a]), g(() => p((e) => {
    var c;
    const r = o.current ? (c = e.get(o.current)) == null ? void 0 : c.index : null;
    r != null && R(r);
  }), [p, R]), u.useMemo(() => ({
    ref: b,
    index: n
  }), [n, b]);
}
export {
  I,
  N as u
};
